import type { Extension } from "@uiw/react-codemirror";
import { cppLanguage } from "@codemirror/lang-cpp";
import { css } from "@codemirror/lang-css";
import { html } from "@codemirror/lang-html";
import { javaLanguage } from "@codemirror/lang-java";
import { javascript } from "@codemirror/lang-javascript";
import { json } from "@codemirror/lang-json";
import { markdown } from "@codemirror/lang-markdown";
import { python } from "@codemirror/lang-python";
import { sql } from "@codemirror/lang-sql";

const LANGUAGES: Record<string, () => Extension> = {
    python,
    py: python,
    java: () => javaLanguage,
    cpp: () => cppLanguage,
    "c++": () => cppLanguage,
    c: () => cppLanguage,
    javascript,
    js: javascript,
    html,
    css,
    sql,
    json,
    markdown,
    md: markdown
};

// The highlighter of a language, or null when there isn't one (the editor still works)
export const getLanguageExtension = (language: string): Extension | null => {
    const create = LANGUAGES[language.toLowerCase()];
    return create ? create() : null;
};